import { Link } from "react-router";
import { buildClassCatalogPath } from "@/utils/catalogSlug";
import {
  LANDING_ASSETS,
  LANDING_CATEGORY_CARD,
  LANDING_CATEGORY_CARD_WIDTH,
  LANDING_CATEGORY_TYPOGRAPHY,
} from "../constants/landing.constants";
import type { LandingCategory, LandingLevel } from "../types/landing.types";
import CategoryIllustration from "./CategoryIllustration";

interface CategoryCardProps {
  category: LandingCategory;
}

function levelHref(level: LandingLevel, categoryId: string): string {
  const params = new URLSearchParams({ level1Id: categoryId });

  // Always carry parent level-1 id so duplicate level-2 names (e.g. Beginner)
  // resolve under the card the user clicked, not the first catalog match.
  if (level.categorySlug) {
    return `${buildClassCatalogPath(level.categorySlug)}?${params.toString()}`;
  }

  return `/classes/level/${level.id}?${params.toString()}`;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <div className={`${LANDING_CATEGORY_CARD_WIDTH} ${LANDING_CATEGORY_CARD.shell}`}>
      <div className={LANDING_CATEGORY_CARD.header}>
        <div className="flex h-full items-start justify-between gap-3">
          <div className="min-w-0 flex-1 pl-[6px] md:pl-0">
            <h3 className={LANDING_CATEGORY_TYPOGRAPHY.title} title={category.title}>
              {category.title}
            </h3>
            <p
              className={LANDING_CATEGORY_TYPOGRAPHY.description}
              title={category.description}
            >
              {category.description}
            </p>
          </div>
          <CategoryIllustration
            src={category.icon}
            className={LANDING_CATEGORY_CARD.illustration}
          />
        </div>
      </div>

      <div className={LANDING_CATEGORY_CARD.body}>
        <p className={LANDING_CATEGORY_TYPOGRAPHY.levelsLabel}>Our levels</p>

        <div className={LANDING_CATEGORY_CARD.levelList}>
          {category.levels.map((level) => (
            <Link
              key={level.id}
              to={levelHref(level, category.id)}
              className={LANDING_CATEGORY_TYPOGRAPHY.levelRow}
            >
              <img
                src={level.thumbnail}
                alt=""
                className={LANDING_CATEGORY_TYPOGRAPHY.levelThumbnail}
              />
              <span className={LANDING_CATEGORY_TYPOGRAPHY.levelTitle} title={level.title}>
                {level.title}
              </span>
              <img
                src={LANDING_ASSETS.icons.chevronRight}
                alt=""
                className={LANDING_CATEGORY_TYPOGRAPHY.levelChevron}
                aria-hidden
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
